/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './EligibilitySummary.scss'
import parse from 'html-react-parser'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { IBaseSection, IPartAActive, ICoverageDiscoveryResponseStateManager } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import { EligibilityStatus } from '../../../../configuration/Enums/EligibilityStatus'

// eslint-disable-next-line
export interface IEligibilitySummaryProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IEligibilitySummaryState {}

export class EligibilitySummaryComponent extends React.Component<IEligibilitySummaryProps, IEligibilitySummaryState> {
	getMedicareActivities(val: IPartAActive[]): string {
		return val.reduce(function(result, current, idx) {
			return idx === 0 ? CommonUtils.DateRange(current.item1, current.item2) : result + (Object.keys(current).length > 0 ? '<br />' : '') + CommonUtils.DateRange(current.item1, current.item2)
		}, '')
	}

	renderEligibilitySummary(section: IBaseSection): JSX.Element {
		let tabHeader: any
		let tabimag: any
		let body = ''
		let curCol = 0
		const columns: string[] = []
		let network = ''
		let index = 1
		const summary = section.eligibilitySummary
		const styleClass = !summary ? 'eligibility-summary status-active' : summary.eligibilitySummaryStatus.classColor

		if (summary) {
			if (summary.managedCareCoordinatorName && summary.managedCareCoordinatorName.trim() !== '') {
				columns.push('Managed Care Coordinator:')
				columns.push(summary ? summary.managedCareCoordinatorName : '')
				columns.push('&nbsp')
				columns.push('&nbsp')
			}
			if (summary.planNetwork) {
				summary.planNetwork.forEach(function(value) {
					network += index === 1 ? value : ', ' + value
					index++
				})
			}

			if (summary.planDescription.length > 0) {
				columns.push('Plan Name:')
				columns.push(summary.planDescription + '<br/>' + network)
				columns.push('Effective Date:')
				columns.push(summary.planDate !== '' ? summary.planDate : '')
			}

			if (!CommonUtils.isMinDate(summary.dateOfDeath)) {
				columns.push('Date of Death:')
				columns.push("<span style='color:red;'>" + CommonUtils.getDate(summary.dateOfDeath, 'MM/DD/YYYY') + '</span>')
			}

			if (summary.partAActives.length > 0) {
				columns.push('Eligible Date Medicare Part A:')
				columns.push(this.getMedicareActivities(summary.partAActives))
			} else {
				columns.push('Medicare Part A:')
				columns.push("<span style='color:red;'>Inactive</span>")
			}

			if (summary.partBActives.length > 0) {
				columns.push('Eligible Date Medicare Part B:')
				columns.push(this.getMedicareActivities(summary.partBActives))
			} else {
				columns.push('Medicare Part B:')
				columns.push("<span style='color:red;'>Inactive</span>")
			}

			if (!CommonUtils.isNullUndefinedEmpty(summary.partAEntitlementReason) || !CommonUtils.isNullUndefinedEmpty(summary.partBEntitlementReason)) {
				columns.push('Entitlement Reason Medicare Part A:')
				columns.push(CommonUtils.isNullUndefinedEmpty(summary.partAEntitlementReason) ? '' : summary.partAEntitlementReason)
				columns.push('Entitlement Reason Medicare Part B:')
				columns.push(CommonUtils.isNullUndefinedEmpty(summary.partBEntitlementReason) ? '' : summary.partBEntitlementReason)
			}

			if (summary.inactivePeriods.length > 0) {
				columns.push('Inactive Periods')
				columns.push(this.getMedicareActivities(summary.inactivePeriods))
			}
			body += '<table class="eligibility-summary-subcontent"><tbody>'
			columns.forEach(function(value) {
				if (curCol % 4 === 0) {
					body += '<tr>'
				}
				body += '<td class="bottom-border-td">' + value + '</td>'
				if (curCol % 4 === 3) {
					body += '</tr>'
				}
				curCol++
			})
			if (curCol % 4 === 2) {
				body += '<td>&nbsp;</td><td>&nbsp;</td></table>'
			}
			body += '</tbody></table>'
			if (CommonUtils.isUndefinedOrNull(summary.eligibilitySummaryStatus)) {
				tabHeader = <h3 className="eligibility-summary-title">Eligibility Summary</h3>
			} else {
				const activeResponseEligibility = this.props.CoverageDiscoveryResponseStateManager.activeResponseEligibility
				const statusDescription = summary.eligibilitySummaryStatus.description
				const toolTip = summary.eligibilitySummaryStatus.toolTip
				tabHeader = (
					<h3 className="eligibility-summary-title" title={toolTip}>
						Eligibility Summary: {statusDescription}
					</h3>
				)
				// eslint-disable-next-line  @typescript-eslint/no-var-requires
				tabimag = <img src={require('../../../../img/Eligibility/' + summary.eligibilitySummaryStatus.largeImage).default} alt="" style={{ float: 'right', paddingRight: '10px', paddingTop: '8px', width: '30px' }} />
			}
		}
		return (
			<table className={styleClass} style={{ width: '100%' }}>
				<thead>
					<tr>
						<th colSpan={4}>
							{tabHeader}
							{tabimag}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td colSpan={4} style={{ padding: 0 }}>
							{parse(body)}
						</td>
					</tr>
				</tbody>
			</table>
		)
	}

	render(): React.ReactNode {
		const section = this.props.CoverageDiscoveryResponseStateManager.selectedMedicareEligibilitySection
		if (!this.props.CoverageDiscoveryResponseStateManager.selectedMedicareEligibilitySection) return <></>
		else {
			return <div className="cdResponsePage">{this.renderEligibilitySummary(section)}</div>
		}
	}
}
